import React from "react";
import { Table } from "react-bootstrap";
import TestReport from "../Components/My-assessment/test-report";

const AssessmentStage = ({
  candidate,
  currentStage,
  currentStatus,
  assessmentInviteDetails,
  latestJob,
  tabLoading,
  isSharedReport,
  formatDateOnly,
  formatDateTime,
  navigate,
  setShowVideoModal,
  setModalType,
  assessmentStatus,
  initiatingVideoCall,
  inlineReportId,
  setInlineReportId,
  showInlineReport,
  setShowInlineReport,
  useSharedToken,
}) => {
  const isMobile = window.innerWidth < 767;

  if (tabLoading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border" />
      </div>
    );
  }

  return (
  <div style={{ padding: isMobile ? '' :"22px 32px" }}>
    {tabLoading ? (
      <div
        className="loading-overlay"
        style={{
          position: "relative",
          marginTop: 16,
          alignItems: "start",
        }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : (
      <>
        {!currentStage ? (
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            {!latestJob?.assessment_id || latestJob?.assessment_id === null ? (
              <>
                <p
                  style={{
                    color: "#6b7280",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Assessment was not added. Add it by navigating to My
                  Assessments.
                </p>
                {!isSharedReport && (
                  <button
                    className="candidate-assessment-calling"
                    onClick={() => navigate("/assessments")}
                  >
                    My Assessments
                  </button>
                )}
              </>
            ) : (
              !isSharedReport && (
                <button
                  className="candidate-assessment-calling"
                  onClick={() => {
                    setShowVideoModal(true);
                    setModalType("assessment");
                  }}
                  disabled={initiatingVideoCall}
                >
                  {assessmentStatus === "sending"
                    ? "Assessment sending to candidate..."
                    : assessmentStatus === "sent"
                      ? "Assessment sent to candidate"
                      : "Send an assessment invite"}
                </button>
              )
            )}
          </div>
        ) : currentStatus === "ASSIGNED" ? (
          <p>Assessment assigned, yet to be completed</p>
        ) : currentStatus === "NOT SCHEDULED" ? (
          <p>Assessment assigned, yet to be scheduled</p>
        ) : currentStatus === "SCHEDULED" ? (
          <p>
            Assessment Invite sent. Due date -{" "}
            {formatDateOnly(currentStage.expire_at)}
          </p>
        ) : currentStatus === "ONGOING" ? (
          <p>Assessment in progress</p>
        ) : currentStatus === "EXPIRED" ? (
          <div>
            {!isSharedReport && (
              <button
                className="candidate-assessment-calling"
                onClick={() => {
                  setShowVideoModal(true);
                  setModalType("assessment");
                }}
                disabled={initiatingVideoCall}
              >
                {assessmentStatus === "sending"
                  ? "Assessment sending to candidate..."
                  : assessmentStatus === "sent"
                    ? "Assessment sent to candidate"
                    : "Send an assessment invite"}
              </button>
            )}
            <p>Assessment stage expired</p>
          </div>
        ) : ["FAILED", "NOT COMPLETED", "REVOKED"].includes(currentStatus) ? (
          <div>
            {!isSharedReport && (
              <button
                className="candidate-assessment-calling"
                onClick={() => {
                  setShowVideoModal(true);
                  setModalType("assessment");
                }}
                disabled={initiatingVideoCall}
              >
                {assessmentStatus === "sending"
                  ? "Assessment sending to candidate..."
                  : assessmentStatus === "sent"
                    ? "Assessment sent to candidate"
                    : "Send an assessment invite"}
              </button>
            )}
            <p>Assessment failed or not completed</p>
          </div>
        ) : currentStatus === "COMPLETED" && assessmentInviteDetails ? (
          assessmentInviteDetails.status === 3 ? (
            <TestReport
              overrideState={{
                id: assessmentInviteDetails.inviteId,
                type: "new",
              }}
              isSharedReport={isSharedReport}
              useSharedToken={useSharedToken}
            />
          ) : (
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
              }}
            >
              <Table responsive className="job-table" style={{ margin: "0" }}>
                <thead>
                  <tr
                    style={{
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                    }}
                  >
                    <th>Test</th>
                    <th>Test Attempt Date</th>
                    <th>Score</th>
                    <th>Status</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: "0px" }}>
                    <td>{assessmentInviteDetails.testName}</td>
                    <td>
                      {assessmentInviteDetails.testAttemptDate
                        ? formatDateTime(
                            assessmentInviteDetails.testAttemptDate,
                          )
                        : "--"}
                    </td>
                    <td>
                      {assessmentInviteDetails.status === 3
                        ? `${assessmentInviteDetails.score ?? "N/A"}%`
                        : "--"}
                    </td>
                    <td>
                      {{
                        1: "Invited",
                        2: "Pending",
                        3: "Completed",
                      }[assessmentInviteDetails.status] || "Unknown"}
                    </td>
                    <td>
                      {assessmentInviteDetails?.status === 3 &&
                        assessmentInviteDetails?.inviteId && (
                          <img
                            className="cursor-pointer"
                            src="/images/view-icon.svg"
                            alt="View"
                            onClick={() => {
                              setInlineReportId(
                                assessmentInviteDetails.inviteId,
                              );
                              setShowInlineReport(!showInlineReport);
                            }}
                          />
                        )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )
        ) : (
          <p>Status pending or unknown</p>
        )}
      </>
    )}
  </div>
  );
};

export default AssessmentStage;
